import React from "react";
import { ToastContainer } from "react-toastify";
import ReArrangeSubCategory from "../../components/ProductManager/SubCategory/ReArrangeSubCategory";

export const ReArrangeSubCategoryPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ReArrangeSubCategory />
        </div>
      </div>
    </div>
  );
};
